import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import packageJson from '../../package.json';
import { GenerateRouteService } from './common/service/generate-route.service';
import { WindowService } from './common/service/window.service';
import { I18nService } from './common/service/i18n.service';
import { ResponsiveService } from './common/service/responsive.service';
import { MatDialog } from '@angular/material/dialog';
import { CookiesService } from './common/service/cookies-service.service';
import { Subscription, filter } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { CookiesConfigComponent } from './common/components/cookies-config/cookies-config.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  routeSubscription!: Subscription;
  mobileXS: boolean = this.responsiveService.mobileXS();
  isMobile: boolean = this.responsiveService.isMobile();
  isTablet: boolean = this.responsiveService.isTablet();
  isLandscape: boolean = this.responsiveService.isLandscape();
  isPC: boolean = this.responsiveService.isPC();
  isFirefox: boolean = false;
  public version: string = packageJson.version;

  constructor(
    private router: Router,
    private generateRouteService: GenerateRouteService,
    private windowService: WindowService,
    private i18nService: I18nService,
    private responsiveService: ResponsiveService,
    private dialog: MatDialog,
    private cookiesService: CookiesService,
  ) { }

  ngOnInit(): void {
    if (this.windowService.isBrowser) {
      this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
      const selectedCookies = localStorage.getItem('selectedCookies');
      if (!selectedCookies) {
        this.openCookiesConfigDialog();
      } else {
        this.loadScripts();
      }
    }

    this.adjustMobileZoom();
    this.makeRouteSubscriptions();

    console.log('eyesNroad ' + this.version);
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  /**
   * Abre el popup para configurar cookies.
   */
  openCookiesConfigDialog() {
    this.dialog
      .open(CookiesConfigComponent, {
        disableClose: true,
        hasBackdrop: true,
        maxWidth: '100%',
        scrollStrategy: new NoopScrollStrategy(),
        panelClass: 'cookiesConfigDialog',
      })
      .afterClosed()
      .subscribe((response) => {
        this.cookiesService.retrieveSelectedCookies();
        this.loadScripts();
      });
  }

  /**
   * Suscripciones
   */
  private makeRouteSubscriptions() {
    this.routeSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.goUp();
      });
  }

  /**
   * Hace scroll al inicio de la página
   */
  goUp(): void {
    if (this.windowService.isBrowser) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  /**
   * Obtiene la ruta en función del idioma actual
   * @param routeKey
   * @returns
   */
  getRouterLink(routeKey: any): string {
    return this.generateRouteService.generateRoute(routeKey);
  }

  /**
   * Actualiza el zoom al redimensionar la ventana
   * @param event
   */
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.mobileXS = this.responsiveService.mobileXS();
    this.isMobile = this.responsiveService.isMobile();
    this.isTablet = this.responsiveService.isTablet();
    this.isLandscape = this.responsiveService.isLandscape();
    this.isPC = this.responsiveService.isPC();
    this.adjustMobileZoom();
  }

  /**
   * Ajusta el zoom de la página
   */
  private adjustMobileZoom() {
    if (this.windowService.isBrowser) {
      const zoomClass = 'zoom';
      if (this.isPC) {
        document.body.classList.add(zoomClass);
        let vw = window.innerWidth;
        let zoom = 1 - (1920 - vw) / 1920;
        document.documentElement.style.setProperty('--zoom', zoom.toString());
      } else if (this.isLandscape) {
        document.body.classList.add(zoomClass);
        let vw = window.innerWidth;
        let zoom = 1 - (1024 - vw) / 1024;
        document.documentElement.style.setProperty('--zoom', zoom.toString());
      } else if (this.isTablet) {
        document.body.classList.add(zoomClass);
        let vw = window.innerWidth;
        let zoom = 1 - (900 - vw) / 900;
        document.documentElement.style.setProperty('--zoom', zoom.toString());
      } else {
        document.body.classList.add(zoomClass);
        let vw = window.innerWidth;
        let zoom = 1 - (390 - vw) / 390;
        document.documentElement.style.setProperty('--zoom', zoom.toString());
        // document.body.classList.remove(zoomClass);
        // document.documentElement.style.removeProperty('--zoom');
      }
    }
  }

  /**
   * Carga los scripts en función de las cookies seleccioandas
   */
  private loadScripts() {
    if (this.cookiesService.hasAnalysisCookies()) {
      // // Crea y añade los elementos script al DOM
      // const scriptElement = document.createElement('script');
      // scriptElement.async = true;
      // scriptElement.src =
      //   'https://www.googletagmanager.com/gtag/js?id=G-96KNG049K8';
      // document.head.appendChild(scriptElement);

      // // Crea y añade el script de configuración al DOM
      // const configScript = document.createElement('script');
      // configScript.innerHTML = `
      //   window.dataLayer = window.dataLayer || [];
      //   function gtag() { dataLayer.push(arguments); }
      //   gtag('js', new Date());
      //   gtag('config', 'G-96KNG049K8');
      // `;
      // // document.head.appendChild(configScript);

      // //Google tag manager
      // const gtmScript = document.createElement('script');
      // gtmScript.innerHTML = `
      //   (function (w, d, s, l, i) {
      //     w[l] = w[l] || []; w[l].push({
      //       'gtm.start': new Date().getTime(), event: 'gtm.js'
      //     });
      //     var f = d.getElementsByTagName(s)[0],
      //       j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
      //       'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
      //   })(window, document, 'script', 'dataLayer', 'GTM-WVNPLNSK');
      // `;
      // document.head.appendChild(gtmScript);

      // // Noscript body etiqueta google
      // const noscriptIframe = document.createElement('iframe');
      // noscriptIframe.src =
      //   'https://www.googletagmanager.com/ns.html?id=GTM-WVNPLNSK';
      // noscriptIframe.height = '0';
      // noscriptIframe.width = '0';
      // noscriptIframe.style.display = 'none';
      // noscriptIframe.style.visibility = 'hidden';
      // document.body.appendChild(noscriptIframe);
    }

    if (this.cookiesService.hasFunctionalityCookies()) {
      // // Crea y añade el script de Clarity al DOM
      // const clarityScript = document.createElement('script');
      // clarityScript.innerHTML = `
      //   (function (c, l, a, r, i, t, y) {
      //     c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
      //     t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
      //     y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
      //   })(window, document, "clarity", "script", "kucf7dhbbm");
      // `;
      // document.head.appendChild(clarityScript);
    }
  }
}
